import { IonButton, IonCol, IonContent, IonIcon, IonPage, IonRow, IonText, IonInput } from "@ionic/react"
import Head from "../Header"
import Select from "react-select"
import Sidebar from "../Sidebar"
import DataTable from "react-data-table-component";
import { useEffect, useState, useMemo } from "react";
import { useHistory } from "react-router";
import service from "../../Service/service";
import swal from 'sweetalert';
import "../../theme/style2.css"
import { searchOutline, chevronDownOutline } from "ionicons/icons";

const ManagerTeams: React.FC = () => {
  const [business, setBusiness] = useState("");
  const [department, setDeapartment] = useState("");
  const [businessUnitArr, setBusinessUnitArr] = useState([]);
  const [departmentUnitArr, setDepartmentUnitArr] = useState([]);
  const history = useHistory();
  const [roleuser] = useState(localStorage.getItem("UserRole"));
  const [createdBy]: any = useState(localStorage.getItem("SignupEmpId"));
  const [Id] = useState(localStorage.getItem("SignupEmpId"));
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  useEffect(() => {
    if (Id === null) {
      history.push("/login");
    } else {
    }
  }, [Id, history]);

  const [data, setData] = useState([]);


  //data.forEach((item: any, index: any) => { item.serial = index + 1; });
   if (Array.isArray(data)) {
  data.forEach((item: any, index: number) => {
    item.serial = index + 1;
  });
}

  const [filterText, setFilterText] = useState("");

  const View = (id: any) => {
    console.log(id, "g")
    history.push({ pathname: "/HRViewEmployee", state: { Id: id } })
  }



  const [selectedOption, setSelectedOption] = useState(null);
  const [inputValue, setInputValue] = useState('');
  const [isFocused, setIsFocused] = useState(false);
  const [menuIsOpen, setMenuIsOpen] = useState(false);

  const [status, setstatus] = useState('')

    //-----------------------Status Autocomplete--------------------//

    const [selectedOption1, setSelectedOption1] = useState(null);
    const [inputValue1, setInputValue1] = useState('');
    const [isFocused1, setIsFocused1] = useState(false);
    const [menuIsOpen1, setMenuIsOpen1] = useState(false);

  const handleStateChange = (selectedOption: any) => {
    setSelectedOption(selectedOption);
  };

  const handleInputChange = (inputValue: any) => {
    setInputValue(inputValue);
  };

  const handleMenuOpen = () => {
    setMenuIsOpen(true);
  };

  const handleMenuClose = () => {
    setMenuIsOpen(false);
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  // const customIconStyle = {
  //   fontSize: '24px',
  //   color: 'blue',
  // };

  const Placeholder = () => {
    if (inputValue === '' && !selectedOption && !isFocused) {
      return <span style={{ color: "black" }}>Select Business Unit</span>;
    } else {
      return <span style={{ color: "black" }}>Type to Search Here...</span>;
    }
  };

  const DropdownIndicator: any = ({ innerProps, selectProps }: any) => {
    const [isClicked, setIsClicked] = useState(false);

    useEffect(() => {
      if (isClicked && !selectProps.menuIsOpen) {
        setIsClicked(false);
      }
    }, [selectProps.menuIsOpen]);

    let icon;
    if (isClicked || selectProps.menuIsOpen) {
      icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
    } else {
      icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
    }

    const handleIconClick = () => {
      setIsClicked(true);
    };

    return (
      <div {...innerProps}>
        <div onClick={handleIconClick}>{icon}</div>
      </div>
    );
  };
  // const cancelDelModal = () => {
  //     setModalopen(false);
  // }

  // const cancelModal = () => {
  //     setModalOp(false);
  // }
  const optionss = [
    { value: '1', label: 'Active' },
    { value: '2', label: 'Inactive' },
]
const handlestatusChange=(selectedOption1:any)=>{
  setstatus(selectedOption1.value)
}
const handleInputChange1 = (inputValue1: any) => {
  setInputValue1(inputValue1);
};

const handleMenuOpen1 = () => {
  setMenuIsOpen1(true);
};

const handleMenuClose1 = () => {
  setMenuIsOpen1(false);
};

const handleFocus1 = () => {
  setIsFocused1(true);
};

const handleBlur1 = () => {
  setIsFocused1(false);
};
const Placeholders = () => {
  if (inputValue1 === '' && !selectedOption1 && !isFocused1) {
      return <span style={{ color: "black" }}>Select Status</span>;
  } else {
      return <span style={{ color: "black" }}>Type to Search Here...</span>;
  }
};

const DropdownIndicators: any = ({ innerProps, selectProps }: any) => {
  const [isClicked, setIsClicked] = useState(false);

  useEffect(() => {
      if (isClicked && !selectProps.menuIsOpen) {
          setIsClicked(false);
      }
  }, [selectProps.menuIsOpen]);

  let icon;
  if (isClicked || selectProps.menuIsOpen) {
      icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
  } else {
      icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
  }

  const handleIconClick = () => {
      setIsClicked(true);
  };

  return (
      <div {...innerProps}>
          <div onClick={handleIconClick}>{icon}</div>
      </div>
  );
};
  const options = [

    ...businessUnitArr.map((state: any) => ({
      value: state.id,
      label: state.businessUnitName,
    })),
    {
      value: 'all',
      label: 'All',
    },
  ];
  const handleBusinessUnitChange = (selectedOption: any) => {
    console.log(selectedOption.value, "kn");
    setBusiness(selectedOption.value);
    ViewAllDepartmentunit(selectedOption.value);
  };
  const handleDepartmentUnitChange = (selectedOption: any) => {
    setDeapartment(selectedOption.value);
  };

  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [departmentInputValue, setDepartmentInputValue] = useState('');
  const [departmentIsFocused, setDepartmentIsFocused] = useState(false);
  const [departmentMenuIsOpen, setDepartmentMenuIsOpen] = useState(false);

  const handleDepartmentChange = (selectedOption: any) => {
    setSelectedDepartment(selectedOption);
  };

  const handleDepartmentInputChange = (inputValue: any) => {
    setDepartmentInputValue(inputValue);
  };

  const handleDepartmentMenuOpen = () => {
    setDepartmentMenuIsOpen(true);
  };

  const handleDepartmentMenuClose = () => {
    setDepartmentMenuIsOpen(false);
  };

  const handleDepartmentFocus = () => {
    setDepartmentIsFocused(true);
  };

  const handleDepartmentBlur = () => {
    setDepartmentIsFocused(false);
  };

  const DepartmentPlaceholder = () => {
    if (
      departmentInputValue === '' &&
      !selectedDepartment &&
      !departmentIsFocused
    ) {
      return <span style={{ color: "black" }}>Select Department Unit</span>;
    } else {
      return <span style={{ color: "black" }}>Type to Search Here...</span>;
    }
  };

  const DepartmentDropdownIndicator: any = ({ innerProps, selectProps }: any) => {
    const [isClicked, setIsClicked] = useState(false);

    useEffect(() => {
      if (isClicked && !selectProps.menuIsOpen) {
        setIsClicked(false);
      }
    }, [selectProps.menuIsOpen]);

    let icon;
    if (isClicked || selectProps.menuIsOpen) {
      icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
    } else {
      icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
    }

    const handleIconClick = () => {
      setIsClicked(true);
    };

    return (
      <div {...innerProps}>
        <div onClick={handleIconClick}>{icon}</div>
      </div>
    );
  };
  const departmentOptions = [
    ...departmentUnitArr.map((state: any) => ({
      value: state.id,
      label: state.departmentName,

    })),
    {
      value: 'all',
      label: 'All',
    },
  ];
  // const handleDepartmentUnitChange = (selectedOption: any) => {
  //   setDeapartment(selectedOption.value);
  // };
  const columns: any = [
    {
      name: "S.No",
      selector: (itm: any, i: any) => itm.serial,
      sortable: true,
      width: "100px",
    },
    {
      name: "Employee Name",
      sortable: true,
      width: "300px",
      cell: (itm: any) => (
        <>
          <div>{itm.name}{" ("}{itm.employeeCode}{")"}</div>
        </>
      )
    },
    {
      name: "Role",
      selector: (itm: any) => itm.role,
      sortable: true,
      width: "230px",
      cell: (itm: any) => (
        <>
          {itm.role === "TEAM_MEMBER" ? <IonText>Team Member</IonText>
            : itm.role === "TEAM_LEADER" ? <IonText>Team Leader</IonText>
              : itm.role === "HR" ? <IonText>Hr</IonText>
                : itm.role === "MANAGER" ? <IonText>Manager </IonText>
                  : itm.role}
        </>
      )
    },
    {
      name: "Email",
      selector: (itm: any) => itm.emailId,
      sortable: true,
      width: "300px"
    },
  
    {
      name: 'Status',
      selector: (itm:any) => itm.statusFlag,
      sortable: true,
      width:"120px",
      cell: (itm:any) => (
          <div style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            {itm.statusFlag === true ? (
              <p style={{ color: "#00b700", margin: '0' }}>ACTIVE</p>
            ) : (
              <p style={{ color: "red", margin: '0' }}>INACTIVE</p>
            )}
          </div>
        )
        
            },
            {
              name: "Action",
              sortable: false,
              cell: (itm: any) => (
                <>
                  <div style={{ textDecoration: 'underline', textDecorationColor: "coral", textUnderlinePosition: "under" }}>
                    <IonText onClick={() => View(itm.id)} style={{ color: "coral", cursor: 'pointer' }}>View</IonText>
                  </div>
                </>
              )
            },
  ];

  const customStyles = {
    headRow: {
      style: {
      },
    },
    headCells: {
      style: {
        fontWeight: "bold",
        fontSize: "15px",
        justifyContent: "center"
      },
    },
    cells: {
      style: {
        fontSize: "16px",
        justifyContent: "center"
      }
    }
  };

  // const datatable = data.filter(
  //   (item: any) =>
  //     JSON.stringify(item)
  //       .toLowerCase()
  //       .indexOf(filterText.toLowerCase()) !== -1
  // );
   const datatable = data?.filter(
  (item: any) =>
    JSON.stringify(item)
      .toLowerCase()
      .indexOf(filterText.toLowerCase()) !== -1
) || [];

  const paginationComponentOptions = {
    selectAllRowsItem: true,
    selectAllRowsItemText: "ALL"
  };

  useEffect(() => {
    LoadEmployee();
  }, []);
  const LoadEmployee = () => {
    service.ManagerGetAllTeams(Id)
      .then((response) => {
        console.log(response);
        console.log("Employee List", response.data.Data);
        if (response.data.Status === "200") {
          setData(response.data.Data)
          ViewAllBusinessunit()

        }
        else {
          setData([])
        }
      })
      .catch((error) => {
        swal(error);
      });
  }
  const Empsort = () => {
    service.SearchEmployeeByBussinessUnit(createdBy, business, department, status)
      .then((response) => {
        console.log(response);
        if (response.data.Status === "200") {
          setData(response.data.Data);
          // sortedTableData()
        } else {
          setData([])
        }
      })
  }
  const ViewAllBusinessunit = () => {
    service.GetBusinessunitEmployee(Id)

      .then((response) => {
        console.log("Bussiness Unit")
        console.log(response);
        if (response.data.Status === "200") {
          setBusinessUnitArr(response.data.Data)
          ViewAllDepartmentunit1()

        }
        else {
          setBusinessUnitArr([])
        }
      })
  }
  const ViewAllDepartmentunit = (id: any) => {
    // setDepartmentUnitArr([]);
    setDeapartment("");
    service.GetAllDepartmentUnitDropDown(id)
      .then((response) => {
        console.log("Department Unit")
        console.log(response);
        if (response.data.Status === "200") {
          setDepartmentUnitArr(response.data.Data)
        } else {
          setBusinessUnitArr([])
        }
      })
  }

  const ViewAllDepartmentunit1 = () => {
    service.GetAllDepartmentUnitDropDown(business)
      .then((response) => {
        console.log("Department Unit")
        console.log(response);
        if (response.data.Status === "200") {
          setDepartmentUnitArr(response.data.Data)
        } else {
          setDepartmentUnitArr([])
        }
      })
  }
  const subHeaderComponent = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };
    return (
      <div style={{ display: "flex" }}>
        <div style={{ display: "flex" }}>
          <div className="form-group form-focus row">
            <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
              value={filterText} placeholder="Search" />
            <label className="focus-label">Search</label>
          </div>
          <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
        </div>
      </div>
    )
  }, [filterText, resetPaginationToggle]);

  return (
    <IonPage>
      <Head />
      <Sidebar />
      <IonContent>
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row">
              <div className="col">
                <h3 className="page-title" style={{ fontWeight: "bold" }}>My Employees</h3>
              </div>
            </div>
          </div>
          <div>
            <form className="row addmore">
              {roleuser === 'BUSINESS_UNIT_HEAD' && (
                <div className="form-group col-md-3">
                  <label style={{ fontWeight: "bold" }}>
                    Business Unit<span className="text-danger">*</span>
                  </label>
                  <div>
                    <Select
                      options={options}
                      value={options.find((option) => option.value === business) || null}
                      onChange={handleBusinessUnitChange}
                      onInputChange={handleInputChange}
                      onMenuOpen={handleMenuOpen}
                      onMenuClose={handleMenuClose}
                      onFocus={handleFocus}
                      onBlur={handleBlur}
                      menuIsOpen={menuIsOpen}
                      isSearchable
                      placeholder={<Placeholder />}
                      components={{
                        DropdownIndicator: DropdownIndicator,
                      }}
                      className="custom-select2"
                    />
                  </div>
                </div>
              )}

              {roleuser === 'BUSINESS_UNIT_HEAD' && (
                <div className="form-group col-md-3">
                  <label style={{ fontWeight: "bold" }}>
                    Department Unit <span className="text-danger">*</span>
                  </label>
                  <div>
                    <Select
                      options={departmentOptions}
                      value={departmentOptions.find((option) => option.value === department) || null}
                      onChange={handleDepartmentUnitChange}
                      onInputChange={handleDepartmentInputChange}
                      onMenuOpen={handleDepartmentMenuOpen}
                      onMenuClose={handleDepartmentMenuClose}
                      onFocus={handleDepartmentFocus}
                      onBlur={handleDepartmentBlur}
                      menuIsOpen={departmentMenuIsOpen}
                      isSearchable
                      placeholder={<DepartmentPlaceholder />}
                      components={{
                        DropdownIndicator: DepartmentDropdownIndicator,
                      }}
                      className="custom-select"

                    />
                  </div>
                </div>
              )}
              {roleuser === 'BUSINESS_UNIT_HEAD' && (
                <div className="col-md-3">
                  <div className="form-group">
                    <label style={{ fontWeight: 'bold' }}>Employee Status <span className="text-danger">*</span></label>
                    <div>
                      <Select
                        options={optionss}
                        value={optionss.find((option: any) => option.value === status) || null}
                        onChange={handlestatusChange}
                        onInputChange={handleInputChange1}
                        onMenuOpen={handleMenuOpen1}
                        onMenuClose={handleMenuClose1}
                        onFocus={handleFocus1}
                        onBlur={handleBlur1}
                        menuIsOpen={menuIsOpen1}
                        isSearchable
                        placeholder={<Placeholders />}
                        components={{
                          DropdownIndicator: DropdownIndicators,
                        }}
                        className="custom-select3"
                      />
                    </div>
                  </div>
                </div>
              )}
              {roleuser === 'BUSINESS_UNIT_HEAD' && (
                <div className="form-group col-md-3">
                  <label>
                    <span className="text-danger"></span>
                  </label>
                  <div>
                    <button onClick={() => Empsort()} type="button" className="btn btn-primary submit-btn">
                      Search
                    </button>
                  </div>
                </div>
              )}
            </form>
          </div>
          <div className="table-responsive">
            <DataTable
              columns={columns}
              data={datatable}
              pagination
              paginationPerPage={10}
              paginationComponentOptions={paginationComponentOptions}
              paginationRowsPerPageOptions={[10, 20, 30]}
              subHeader
              subHeaderComponent={subHeaderComponent}
              customStyles={customStyles}
            />
          </div>
        </div>
      </IonContent>
    </IonPage>
  )
}

export default ManagerTeams